/**
 * Containerul de care atarna tot ce facem in piata: actiuni de teren, plasari media,
 * materiale consumate.
 *
 * Cele trei tipuri au cicluri de viata DIFERITE, nu unul comun — fisa tehnica v0.2 le
 * descrie separat, la §3.1 (campanii) si §4.1 (evenimente). De aceea starea nu e un enum
 * Prisma, ci un sir validat dupa tip.
 */
/*
  Cinci tipuri, nu trei.

  Solicitare din partea echipei: „la Tip — publicatie/revista" si „si o a 5-a categorie —
  «spatiu publicitar»", cu explicatia: „in categoria aceasta voi putea inregistra tot ce inseamna
  chirii cu spatiile publicitare, de la bannere pe DN1, pana la colantarea metrorex".

  Amandoua sunt PLASARI cumparate pe o perioada, nu actiuni pe care le desfasuram noi. De aceea
  imprumuta ciclul de viata al campaniei — se discuta, se agreeaza, ruleaza, se incheie — nu pe cel
  al evenimentului, unde „participat" descrie prezenta noastra undeva.
*/
export const TIPURI_CAMPANIE = [
    'campanie',
    'eveniment',
    'program',
    'publicatie',
    'spatiu_publicitar',
    'articol_presa',
    'barter_social_media',
    'cross_marketing',
    'sponsorizare',
    'expunere',
    'altele',
];
/** Medical / non-medical, valorile fostului registru de evenimente. */
export const TIP_EVENIMENT = ['medical', 'non_medical'];
export const STARI_CAMPANIE = ['planificata', 'agreata', 'activa', 'incheiata', 'anulata'];
export const STARI_EVENIMENT = [
    'oportunitate',
    'in_evaluare',
    'confirmat',
    'participat',
    'anulat',
];
/** Programele nu se compun, se genereaza — de aici si ciclul scurt. */
export const STARI_PROGRAM = ['activ', 'inchis'];
/** Starile permise pentru un tip. */
export const STARI_PE_TIP = {
    campanie: STARI_CAMPANIE,
    eveniment: STARI_EVENIMENT,
    program: STARI_PROGRAM,
    publicatie: STARI_CAMPANIE,
    spatiu_publicitar: STARI_CAMPANIE,
    articol_presa: STARI_CAMPANIE,
    /*
      Barterul are ciclul campaniei, nu al evenimentului: se discuta, se agreeaza, ruleaza cat tine
      intelegerea, se incheie. „Participat" descrie prezenta noastra undeva; la un barter nimeni nu
      participa la nimic.
    */
    barter_social_media: STARI_CAMPANIE,
    cross_marketing: STARI_CAMPANIE,
    sponsorizare: STARI_CAMPANIE,
    /*
      Expunerea e tot o PLASARE cumparata pe o perioada, ca spatiul publicitar: se discuta, se
      agreeaza, ruleaza cat tine intelegerea, se incheie. Diferenta fata de acela e doar unde sta
      plasarea — la partener, nu in spatiu public.
    */
    expunere: STARI_CAMPANIE,
    altele: STARI_CAMPANIE,
};
/**
 * Starea cu care se creeaza un container. O impune serverul, nu clientul: altfel o campanie
 * s-ar putea naste direct „incheiata".
 */
export const STARE_INITIALA = {
    campanie: 'planificata',
    eveniment: 'oportunitate',
    program: 'activ',
    publicatie: 'planificata',
    spatiu_publicitar: 'planificata',
    articol_presa: 'planificata',
    barter_social_media: 'planificata',
    cross_marketing: 'planificata',
    sponsorizare: 'planificata',
    expunere: 'planificata',
    altele: 'planificata',
};
/**
 * De unde a venit intelegerea.
 *
 * Statea doar in ecran, ca lista de optiuni pe formularul de eveniment. A urcat aici din doua
 * motive: `social_media` s-a adaugat fiindca „unele evenimente provin din abordare pe social
 * media", iar API-ul valida oricum lista — doua liste ale aceluiasi lucru divergeaza la prima
 * schimbare.
 *
 * Nu mai e doar a evenimentelor: un barter sau un articol de presa vine si el de undeva.
 */
export const SURSE_CONTAINER = [
    'email',
    'discutie_directa',
    'propunere_agentie',
    'social_media',
    'altul',
];
export const ETICHETE_SURSA = {
    email: 'Email',
    discutie_directa: 'Discuție directă',
    propunere_agentie: 'Propunere agenție',
    social_media: 'Social media',
    altul: 'Altul',
};
export function stareValidaPentruTip(tip, stare) {
    return STARI_PE_TIP[tip].includes(stare);
}
/**
 * Statusul CANONIC — v2, pentru UI/rapoarte/permisiuni viitoare. Nu inlocuieste `status`-ul
 * stocat pe `Campanie` (ramas RO, per-tip, cel din `STARI_PE_TIP`): e doar o eticheta derivata,
 * calculata la citire, exact ca sa nu apara a DOUA sursa de adevar pentru acelasi lucru — „doua
 * liste ale aceluiasi lucru diverg la prima schimbare", cum s-a intamplat deja cu `sursa`.
 *
 * `needs_closure` NU e aici: nu e un status stocat (ar rupe `stareValidaPentruTip`), ci un semnal
 * DERIVAT — vezi `necesitaInchidere`.
 */
export const STATUS_CANONIC = [
    'opportunity',
    'in_discussion',
    'confirmed',
    'planned',
    'in_progress',
    'completed',
    'canceled',
];
/**
 * Maparea status legacy (cel stocat, RO) -> status canonic. Cheile sunt toate valorile posibile
 * din `STARI_CAMPANIE` + `STARI_EVENIMENT` + `STARI_PROGRAM` — niciun string nu se repeta intre
 * cele trei familii, deci maparea nu are nevoie de `tip` ca sa fie fara ambiguitate.
 */
const MAPARE_STATUS_CANONIC = {
    planificata: 'planned',
    agreata: 'confirmed',
    activa: 'in_progress',
    incheiata: 'completed',
    anulata: 'canceled',
    oportunitate: 'opportunity',
    in_evaluare: 'in_discussion',
    confirmat: 'confirmed',
    participat: 'completed',
    anulat: 'canceled',
    activ: 'in_progress',
    inchis: 'completed',
};
/**
 * Statusul legacy vine dintr-un rand deja salvat, deci mereu validat de `stareValidaPentruTip`
 * la scriere — de aceea parametrul e tipat `StareContainer`, nu `string`: un status invalid nu
 * trebuie sa ajunga niciodata aici.
 */
/** Inceputul zilei, in ora locala — „azi" nu trebuie sa depinda de ora la care se uita cineva. */
function ziua(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}
export function statusCanonic(status) {
    return MAPARE_STATUS_CANONIC[status];
}
/**
 * Activitatea a trecut de data de final, dar inca n-a fost inchisa explicit.
 *
 * NU marcheaza automat statusul — fisa tehnica e explicita: „Nu modifica automat o activitate in
 * «Finalizat» doar pentru ca end_date a trecut". E un semnal derivat, recalculat la fiecare
 * citire, niciodata stocat: altfel ar trebui un job care sa-l tina la zi si ar deveni a treia
 * sursa de adevar pentru „unde suntem".
 */
/**
 * Starile unui `AngajamentCost`. Primele patru sunt „deschise" — intra in Angajat; `facturat` si
 * `anulat` sunt finale si ies din calcul (vezi `STARI_ANGAJAMENT_DESCHISE` din
 * `costuriEveniment/costuri.service.ts`, care trebuie sa ramana in sincron cu primele patru
 * valori de-aici).
 */
export const STARI_ANGAJAMENT = [
    'ofertat',
    'comandat',
    'contractat',
    'in_asteptare_factura',
    'facturat',
    'anulat',
];
export const ETICHETE_STARE_ANGAJAMENT = {
    ofertat: 'Ofertat',
    comandat: 'Comandat',
    contractat: 'Contractat',
    in_asteptare_factura: 'În așteptarea facturii',
    facturat: 'Facturat',
    anulat: 'Anulat',
};
export function necesitaInchidere(dataFinal, status, azi = new Date(), tip, automat = false) {
    // Fara final, activitatea e deschisa pe termen nedefinit — nu se cere inchisa dupa data.
    if (!dataFinal)
        return false;
    /*
      Containerele generate automat (trimestrul de sampling in farmacii, expunerile permanente) le
      face si le tine aplicatia; nu se editeaza de mana, deci n-are cine sa le inchida. Dupa
      perioada lor sunt pur si simplu incheiate — vezi `fazaActivitatii`. Altfel fiecare trimestru
      trecut ar sta la „de inchis" pentru totdeauna.
    */
    if (automat || tip === 'program')
        return false;
    if (status === 'completed' || status === 'canceled')
        return false;
    /*
      Pe ZI, nu pe ora: finalul e ziua intreaga. Comparat cu ora, o activitate care se termina azi
      cerea inchidere chiar din ziua ei (15.10.2026).
    */
    return ziua(dataFinal) < ziua(azi);
}
/** Etichete pentru interfata. Cheile sunt cele din baza. */
export const ETICHETE_STARE = {
    planificata: 'Planificată',
    agreata: 'Agreată',
    activa: 'Activă',
    incheiata: 'Încheiată',
    anulata: 'Anulată',
    oportunitate: 'Oportunitate',
    in_evaluare: 'În evaluare',
    confirmat: 'Confirmat',
    participat: 'Participat',
    anulat: 'Anulat',
    activ: 'Activ',
    inchis: 'Închis',
};
export const ETICHETE_TIP = {
    campanie: 'Campanie',
    eveniment: 'Eveniment',
    program: 'Program',
    publicatie: 'Publicație / revistă',
    spatiu_publicitar: 'Spațiu publicitar',
    articol_presa: 'Articol de presă',
    barter_social_media: 'Barter social media',
    cross_marketing: 'Cross-marketing',
    sponsorizare: 'Sponsorizare',
    expunere: 'Expunere',
    altele: 'Altele',
};
/**
 * Textul implicit de pe bonul de consum al unei cereri expediate direct (AWB + bon).
 *
 * Il folosesc si serverul (cand omul lasa campul gol) si ecranul (ca sugestie), ca sa scrie
 * acelasi lucru. Pana pe 12.10.2026 ecranul sugera „Sponsorizare" la orice partener, iar serverul
 * scria „marketing influencer": niciunul nu era adevarat pentru mostrele date la un eveniment.
 *
 * Doar o activitate de tip `sponsorizare` e sponsorizare — are contract si merge pe alt cont.
 * Marfa trimisa unui partener la orice alta activitate sunt mostre gratuite, nu marfa de vanzare.
 */
export function motivBonImplicit(tipActivitate, tipCerere, destinatar) {
    const ce = tipActivitate === 'sponsorizare'
        ? 'Sponsorizare'
        : tipCerere === 'partener'
            ? 'Mostre gratuite'
            : 'Marketing influencer';
    return destinatar ? `${ce} — ${destinatar}` : ce;
}
/**
 * Faza unei activitati, aceeasi pentru toate tipurile (Madalin, 15.10.2026: „sunt de acord cu
 * cele 5 faze comune; daca ne incurca, schimbam pe parcurs").
 *
 * Nu e stocata: se citeste din starea de azi a tipului si din date, la fiecare afisare. Starile
 * raman cele din `STARI_PE_TIP` — fazele doar le arata la fel, ca lista sa se poata grupa.
 *
 * - `propunere` — inca nu e hotarat (oportunitate, in evaluare, planificata);
 * - `pregatire` — hotarat (agreata, confirmat), dar n-a inceput;
 * - `desfasurare` — ruleaza (activa) sau e azi intre start si final;
 * - `de_inchis` — a trecut de final si nu s-a inchis (vezi `necesitaInchidere`); fara data de
 *   final, nu devine niciodata „de inchis" singura;
 * - `incheiata` / `anulata` — finale.
 */
export const FAZE_ACTIVITATE = [
    'propunere',
    'pregatire',
    'desfasurare',
    'de_inchis',
    'incheiata',
    'anulata',
];
export const ETICHETE_FAZA = {
    propunere: 'Propunere',
    pregatire: 'Pregătire',
    desfasurare: 'În desfășurare',
    de_inchis: 'De închis',
    incheiata: 'Încheiată',
    anulata: 'Anulată',
};
export function fazaActivitatii(status, dataStart, dataFinal, azi = new Date(), tip, 
/** `generatAutomat` — programele si containerul expunerilor. */
automat = false) {
    const canonic = statusCanonic(status);
    if (canonic === 'canceled')
        return 'anulata';
    if (canonic === 'completed')
        return 'incheiata';
    const z = ziua(azi);
    /*
      Un container automat nu se hotaraste si nu se inchide de mana (vezi `necesitaInchidere`):
      ruleaza cat ii tine perioada, apoi e incheiat. Starea lui stocata nu spune nimic — expunerile
      se nasc „planificata" si raman asa.
    */
    if (automat || tip === 'program') {
        if (dataFinal && ziua(dataFinal) < z)
            return 'incheiata';
        return ziua(dataStart) <= z ? 'desfasurare' : 'pregatire';
    }
    // Aceeasi regula ca bannerul de pe pagina activitatii — un singur adevar pentru „de inchis".
    if (necesitaInchidere(dataFinal, canonic, azi, tip, automat))
        return 'de_inchis';
    if (canonic === 'in_progress')
        return 'desfasurare';
    if (canonic === 'confirmed')
        return ziua(dataStart) <= z ? 'desfasurare' : 'pregatire';
    return 'propunere';
}
// ─── Partenerii unei activitati (15.10.2026) ────────────────────────────────────
/**
 * Rolul unui partener pe o activitate — general si simplu, ca sa se stie pentru ce l-am platit
 * (Madalin: „organizator, suport, ceva de genul").
 */
export const ROLURI_PARTENER = [
    'organizator',
    'suport',
    'beneficiar',
    'influencer',
    'partener',
];
export const ETICHETE_ROL_PARTENER = {
    organizator: 'Organizator',
    suport: 'Suport',
    beneficiar: 'Beneficiar',
    influencer: 'Influencer',
    partener: 'Partener',
};
export const DESCRIERE_ROL_PARTENER = {
    organizator: 'face evenimentul; îi plătim taxa sau pachetul',
    suport: 'montaj, tipografie, transport — un serviciu plătit',
    beneficiar: 'primește de la noi marfă sau bani',
    influencer: 'creator de conținut, la barter',
    partener: 'co-sponsor, celălalt brand, redacția',
};
/**
 * Unde se CREEAZA un partener nou, dupa rol: pe cei pe care ii platim ii tinem la furnizori
 * (facturile lor se leaga la Bani), pe ceilalti in registrul de clienti, fara agent.
 */
export function registruPentruRol(rol) {
    return rol === 'organizator' || rol === 'suport' ? 'furnizor' : 'client';
}
/**
 * Daca activitatea trebuie sa aiba partener — de la prima factura legata, nu de la creare.
 * Activitatile create de sistem (programe, expuneri) n-au partener obligatoriu deloc.
 */
export function ceriPartener(tip, generatAutomat = false) {
    return !generatAutomat && tip !== 'program' && tip !== 'expunere';
}
// ─── Echipa la eveniment (24.10.2026) ──────────────────────────────────────────
/**
 * Alocarea e provizorie cat activitatea e inca propunere (nehotarata): se vede doar cu contur si
 * nu se anunta nimeni. Anuntul pleaca cand activitatea se confirma. Aceeasi granita ca faza
 * „Propunere" din `fazaActivitatii`, fara data — o activitate confirmata ramane anuntata.
 */
export function alocareProvizorie(status) {
    const c = statusCanonic(status);
    return c === 'opportunity' || c === 'in_discussion' || c === 'planned';
}
/** Cate zile poate avea un om la o activitate. */
export const ECHIPA_MAX_ZILE = 62;
/** Cat de departe de perioada activitatii poate fi o zi alocata (montajul din ajun, demontajul). */
export const ECHIPA_MARJA_ZILE = 30;
/**
 * Starile „anulat" ale tuturor tipurilor. O activitate anulata nu mai tine pe nimeni ocupat: iese
 * din calendarul echipei, din conflicte si de pe Acasa — omul a primit deja „zilele s-au eliberat".
 */
export const STARI_ANULATE = Object.keys(MAPARE_STATUS_CANONIC).filter((s) => MAPARE_STATUS_CANONIC[s] === 'canceled');
/**
 * Activitatea automata „Necesar teren · Tn AAAA" (26.10.2026): pe ea stau cererile de marfa facute
 * „pentru mine", fara un eveniment anume — mostrele si materialele pe care agentul le duce in
 * teren. Una pe trimestru, creata singura la prima cerere (regula „nimic nu traieste orfan").
 */
export function esteNecesarTeren(cod) {
    return Boolean(cod && /^PRG-\d{4}-T[1-4]-TEREN$/.test(cod));
}
//# sourceMappingURL=campanii.js.map